import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Select from "react-select";

export default class SpecProjShip extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      projects: [],
      ships: [],
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.projectId !== this.props.projectId) {
      this.load();
    }
  }
  load = async () => {
    this.setState({ pending: true });
    let projects = await this.context.api.qr("/project/list");

    let ships = [];
    let shipsSearch = [
      {
        field: "statetypecode",
        compare: "EQL",
        value: "enabled",
      },
      {
        field: "project",
        compare: "EQL",
        value: this.props.projectId || this.context.api.nullUuid,
      },
    ];
    let shipsQuery = await this.context.api.qa("/ship/list", {
      search: shipsSearch,
    });
    if (Array.isArray(shipsQuery)) {
      ships.push({
        value: this.context.api.nullUuid,
        label: "Любое судно по проекту",
      });
      shipsQuery.forEach((item) => {
        ships.push({
          value: item.id,
          label: item.name,
        });
      });
    }

    this.setState({ pending: false, ships, projects });
  };

  onChangeProject = (id) => {
    this.context.redirect(`/spec/${id}/`);
  };

  onChangeShip = (id) => {
    this.context.redirect(
      `/spec/${this.props.projectId || this.context.api.nullUuid}/${id}`
    );
  };

  render() {
    return (
      <>
        <div className="flex-grow-1">
          <Blocker hAuto on={this.state.pending}>
            <div className="d-flex">
              <div className="flex-grow-1 pr-2">
                <Select
                  value={this.context.api.getReferenceValue(
                    this.props.projectId,
                    this.state.projects
                  )}
                  onChange={(result) => this.onChangeProject(result.value)}
                  className="from-control react-select"
                  classNamePrefix="react-select-inner"
                  options={this.state.projects}
                  placeholder="Выберите проект..."
                  noOptionsMessage={({ inputValue }) =>
                    `Ничего не найдено по запросу ${inputValue}`
                  }
                />
              </div>
              <div className="flex-grow-1 pl-2">
                <Select
                  value={this.context.api.getReferenceValue(
                    this.props.shipId,
                    this.state.ships
                  )}
                  onChange={(result) => this.onChangeShip(result.value)}
                  className="from-control react-select"
                  classNamePrefix="react-select-inner"
                  options={this.state.ships}
                  placeholder="Любое судно..."
                  noOptionsMessage={({ inputValue }) =>
                    `Ничего не найдено по запросу ${inputValue}`
                  }
                />
              </div>
            </div>
          </Blocker>
        </div>
      </>
    );
  }
}
